import { Grid } from '@material-ui/core';
import React from 'react';
import BaseButton from 'src/common/components/base-button';
import { pushEmeraldModal } from 'src/common/emerald-modal-manager/emerald-modal-manager';
import { PRICE_ENTRY_KEYPAD_TOP_LABEL } from 'src/common/helpers/config';
import { IItemDetails } from 'src/common/interfaces/dtos/IItemDetails';
import { IButton } from 'src/common/interfaces/IButton';
import Keypad from 'src/keypad/components/keypad';
import { styles } from './price-entry-styles';
import PriceVerificationRequiredSubText from './price-verification-required-subtext';
import { PriceEntryType } from 'src/common/enumerations/price-entry-type';
import { IKeypadModal, KeypadModal } from 'src/common/components/keypad-modal/keypad-modal';
import { useTranslation } from 'react-i18next';
import { getCurrentXLRConfig } from 'src/xlr-configuration/xlr-config';
import { RifmOptions } from 'src/keypad/keypad-operation';

export const showPriceEntryDialog = (props: IPriceEntryProps, modalId: string) => {
  pushEmeraldModal(<PriceEntryModal {...props} />, undefined, modalId);
};

const PriceEntryModal = ({
  onClose,
  onApprove,
  itemDetails,
  priceEntryType,
}: IPriceEntryProps): JSX.Element => {
  const classes = styles();

  const keypadSubmitButton: IButton = {
    label: 'OK',
    onClick: onApprove,
  };

  const isPriceVerify = priceEntryType === PriceEntryType.PriceVerify;
  const { t } = useTranslation();
  const { hidePriceInPriceEntryDialog } = getCurrentXLRConfig();

  const keypadModal: IKeypadModal = {
    onClose: onclose,
    title: '',
    buttonComponent: (
      <Grid item>
        <BaseButton
          buttonType='white'
          className={classes.rejectButton}
          data-testid='price-entry-cancel-button'
          onClick={onClose}
        >
          <span className='label'>{t('Cancel_Button')}</span>
        </BaseButton>
      </Grid>
    ),
    contentArea: (
      <Grid item xs={11} className={classes.container}>
        <Grid container justifyContent='center' direction='column' alignItems='center'>
          <Grid item className={classes.title}>
            {!isPriceVerify && t('EnterNewPrice')}
            {isPriceVerify && t('EnterNewPriceVerify')}
          </Grid>
          <Grid item>
            <h4 className={styles().subBarText}>{t('PriceEntryNewPriceMessage')}</h4>
          </Grid>
        </Grid>
        <Grid item className={`${classes.message} ${classes.paddingPriceEntry}`}>
          <PriceVerificationRequiredSubText
            itemDetails={itemDetails}
            hidePrice={hidePriceInPriceEntryDialog}
            priceEntryType={priceEntryType}
          />
        </Grid>
      </Grid>
    ),
    modalHeight: 78.65,
    modalWidth: 62.36,
    keypad: (
      <Keypad
        keyboardId={'price-entry'}
        visible
        keypadTestIdPrefix={'price-entry-'}
        topLabelText={PRICE_ENTRY_KEYPAD_TOP_LABEL}
        submitButton={keypadSubmitButton}
        disableManualWeight={true}
        replaceDecimalInput
        disableQuantity={true}
        isPriceMode={true}
        formatter={RifmOptions.price}
      />
    ),
  };

  return <KeypadModal {...keypadModal} />;
};

export interface IPriceEntryProps {
  onClose: () => void;
  onApprove: (newprice: string) => void;
  itemDetails: IItemDetails;
  initialPrice: string;
  title: string;
  priceEntryType: PriceEntryType;
}

export default PriceEntryModal;
